




import { Component, Mixins } from 'vue-property-decorator';
import OverviewMixin from '@/mixins/OverviewMixin';
import FieldDefs from './FieldDefs';

@Component
export default class ResponsiblesOverview extends Mixins(OverviewMixin) {
  public tableCfg = FieldDefs;
}
